const GEO_BOUNDARY_TYPE = "Polygon";
function buildClosedCoordinates(geoFenceCoordinates) {
    const coordinatesArray = geoFenceCoordinates?.map((coord) => [coord.lng, coord.lat]) || [];
    if (coordinatesArray.length > 0) {
        const first = coordinatesArray[0];
        const last = coordinatesArray[coordinatesArray.length - 1];
        if (first[0] !== last[0] || first[1] !== last[1]) {
            coordinatesArray.push([...first]);
        }
    }
    return coordinatesArray;
}
export function prepareCreateGeoFenceRequest(values) {
    const coordinates = buildClosedCoordinates(values.geoFenceCoordinates);
    return {
        description: values.geofenceDesc,
        geoBoundary: {
            coordinates,
            type: GEO_BOUNDARY_TYPE
        },
        geofenceDisplayName: values.geofenceName,
        geofenceType: values.geofenceType
    };
}
export function prepareUpdateGeoFenceRequest(values) {
    const coordinates = buildClosedCoordinates(values.geoFenceCoordinates);
    return {
        description: values.geofenceDesc,
        geoBoundary: {
            coordinates,
            type: GEO_BOUNDARY_TYPE
        },
        geofenceDisplayName: values.geofenceName
    };
}
